import { Badge } from "components/ui";
import { useTranslation } from "hooks/useTranslation";
import { KbDocumentStatus } from "types/knowledgeBase";

interface DocumentStatusBadgeProps {
  status: KbDocumentStatus;
}

const DocumentStatusBadge = ({ status }: DocumentStatusBadgeProps) => {
  const { t } = useTranslation();

  const getColorPalette = () => {
    switch (status) {
      case KbDocumentStatus.Indexed:
        return "green";
      case KbDocumentStatus.Processing:
      case KbDocumentStatus.Uploaded:
        return "yellow";
      case KbDocumentStatus.Failed:
        return "red";
      case KbDocumentStatus.Deleted:
        return "gray";
      default:
        return "gray";
    }
  };

  const getStatusText = () => {
    switch (status) {
      case KbDocumentStatus.Indexed:
        return t("app.knowledgeBase.status.indexed");
      case KbDocumentStatus.Processing:
      case KbDocumentStatus.Uploaded:
        return t("app.knowledgeBase.status.processing");
      case KbDocumentStatus.Failed:
        return t("app.knowledgeBase.status.failed");
      case KbDocumentStatus.Deleted:
        return t("app.knowledgeBase.status.deleted");
      default:
        return status;
    }
  };

  return <Badge colorPalette={getColorPalette()}>{getStatusText()}</Badge>;
};

export default DocumentStatusBadge;
